angular.module('dealerware.web.data').factory('DealerwareFleetCollection', function ($rootScope,$http,Collection,DealerwareFleetModel,$q) {

    'use strict';
    var collection = new Collection({
        baseEndpoint: '/locations/:location_id/fleet',
        model: 'DealerwareFleetModel',
        responseTransforms: new function() {
            this.index = function(args, data) {
                data.forEach(function(car) {
                    for (var k in car.data.last_car_scan) {
                        car.data[k] = car.data.last_car_scan[k];
                    }
                    delete car.data.last_car_scan;
                });
            };

            this.forLocation = function(args, data) {
                data.forEach(function(car) {
                    for (var k in car.data.last_car_scan) {
                        if (k === 'fuel' || k === 'mileage')
                            car.data[k] = car.data.last_car_scan[k];
                    }

                    for (var k in car.data.last_connected_car_scan) {
                        if (k === 'latitude' || k === 'longitude' || k === 'created_at' || k === 'event_type') {
                            car.data[k] = car.data.last_connected_car_scan[k];
                        } else if (k === 'device') {
                            car.data['scan_source'] = car.data.last_connected_car_scan[k];
                        }
                    }

                    delete car.data.last_car_scan;

                    car.data.fuel_level = $rootScope.calculateFuelLevel(car.data.fuel, car.data.fuel_capacity);
                });
            };
        },
        customActions: {
            index: {
                method: 'GET',
                ignoreDefaultAssociationMapper: true
            },
            forLocation: {
                endpoint: '/locations/:location_id/mappable_fleet',
                method: 'GET',
                ignoreDefaultAssociationMapper: true
            }
        }
    });

    return collection;
});
